import { ComponentType, HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface FieldLabelProps extends HTMLAttributes<HTMLLabelElement> {
  size?: "small" | "medium" | "large";
}

export const FieldLabel: ComponentType<FieldLabelProps> = ({
  size,
  className,
  children,
  ...props
}) => {
  return (
    <label
      className={cn(
        // Base styles (h4 typography + custom styles)
        "block font-medium text-foreground",
        // Default size (21px font, 12px margin-bottom)
        "text-[21px] mb-0.75",
        // Arabic locale support
        "ar:text-[18px]",
        // Size variants
        {
          "text-sm": size === "small", // 14px
          "text-lg mb-0.5": size === "medium", // 18px, 8px margin
          "text-2xl mb-[18px]": size === "large", // 24px, 18px margin
        },
        className,
      )}
      {...props}
    >
      {children}
    </label>
  );
};

export default FieldLabel;
